<template>
<div class="content">
  <div class="img-scroll">
    <img src="../../assets/images/scroll.png" alt="" >
  </div>
  <div class="main-content">
    <div class="content-img">
    <img src="../../assets/images/postcontent1.jpg" alt="" >
    </div>
    <div class="post">
        <div class="detail"  :style="{zoom:zoomRate}">
          <div class="title">
            尊敬的金融系统劳模 {{trimname}}:
          </div>
          <div class="content">
            <p>瑞犬凯歌辞旧岁，金猪送福迎新春。值此新春佳节来临之际，中国金融工会全国委员会谨向全国金融系统各条战线的劳动模范、先进工作者和全国(金融)五一劳动奖章获得者，致以诚挚的问候和崇高的敬意!</p>
            <p>海纳百川，万物向阳。2018 年，对金融系统职工来说， 是不平凡的一年，也是颇具纪念意义的一年。在这贯彻党的 十九大精神的开局之年，在这决战脱贫攻坚、决胜同步小康、 实施“十三五”规划至关重要的一年，面对严峻复杂的国际国 内形势，以习近平同志为核心的党中央团结带领全国各族人 民，众志成城，奋力拼搏，推动经济建设、政治建设、文化 建设、社会建设、生态文明建设和党的建设取得新的成就， 为改革开放 40 周年交上了圆满答卷。</p>
            <p>劳动最光荣，劳动最伟大。劳动模范是劳动群众的杰出 代表，是我国工人阶级中的闪光群体，享有崇高声誉、备受 尊敬。2018 年，广大金融系统劳动模范以习近平新时代中国 特色社会主义思想为指导，在以习近平同志为核心的党中央的坚强领导下，主动服务国家总体战略，围绕金融服务实体经济、深化供给侧结构性改革、增强金融防范化解风险能力等，大力弘扬和践行劳模精神、劳动精神、工匠精神，立足本职、勇担使命，在推动我国金融业的改革发展稳定中发挥了突出的示范带动作用，用实际行动创造了无愧于新时代的光辉业绩，谱写了新时代的劳动者之歌。</p>
            <p>致敬来时路，整装再出发。2019 年是新中国成立 70 周年，是决胜全面建成小康社会的关键之年。面对这样一个千帆竞 发、百舸争流的时代，我们深信，广大金融系统的劳动模范 一定会更加紧密地团结在以习近平同志为核心的党中央周 围，不忘初心、继续前进，以实际行动引领广大金融职工， 牢牢把握为实现中国梦而奋斗的时代主题，把自身前途命运 同国家和民族前途命运紧紧联系在一起，把个人梦同中国梦 紧密联系在一起，爱岗敬业、创新进取、争创一流，以不懈 奋斗书写新时代华章，以优异成绩向中华人民共和国成立 70 周年献礼!</p>
            <p>草木蔓发，春山可望。在这新春佳节即将到来的美好时刻，衷心祝愿金融系统劳动模范和广大劳动者新春快乐、工作顺利、健康平安、阖家幸福!</p>
          </div>
          <div class="footer">
            <div>中国金融工会全国委员会</div>
            <div>己亥年春节&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
          </div>
        </div>
    </div>
    <div class="bottom-scroll">
    <img src="../../assets/images/scroll.png" alt="">

    </div>
  </div>

</div>

</template>
<script>
  export default{
    data(){
      return {
        zoomRate:1,
        name:this.$route.params.name
      }
    },
    computed: {
      trimname(){
        return this.$route.params.name.replace(/\+/g, '');
      }
    },
    mounted() {
      console.log(screen.height)
      let screenHeight=screen.height;
      if(screenHeight>667){
        this.zoomRate=0.95
      }else if (screenHeight<=667 && screenHeight>640) {
        this.zoomRate=0.9
      }else if(screenHeight<=640 && screenHeight>568){
        this.zoomRate=0.85
      }else{
        this.zoomRate=0.65
      }
    },
  }
</script>
<style lang="less" scoped>
@keyframes anni {
  0% {
    height:0;
  }
  99% {
    height:100vh;
  }
  100% {
    height:auto;
  }
}
.content{
  position: relative;
  .main-content{
    position: relative;
    animation: anni 10000ms linear;
    overflow: hidden;
  }
  .content-img{
    img{
      width:94%;
      margin:0 auto;
      display: block;
    }
  }
  .img-scroll{
    width:100%;
    img{
      width:100%;
      display: block;
    }
  }
  .bottom-scroll{
    position:absolute;
    left:0;
    right:0;
    bottom:0;
    img{
      width:100%;
      display: block;
    }
  }
}
.post{
  position: absolute;
  left:15%;
  right:15%;
  top:170px;
  .detail{
    width:100%;
    font-weight:bold;
    color:rgba(0,0,0,1);
    line-height:1.4;
    font-size: 16px;
    .title{
      margin-bottom: 6px;
    }
    .content{
      text-indent: 2em;
      text-align: justify;
      text-align-last: left;
      font-size: 15px;
      font-weight: 500;
      >p{
        margin: 0;
      }
    }
    .footer{
      margin-top: 6px;
      text-align: right;
    }
  }
}
</style>
